module.exports = __webpack_public_path__ + "img/emptystate_wrench.239943d3.svg";